<template>
  <v-card>
    <v-row justify="center">
     <v-dialog v-model="dialogRemoveRoute" persistent width="600">
      <v-card class="text-center">
        <v-card-title>
         <p class="text-md-left">{{$t("deleteconfirm")}} <b style="color:red;font-size:16px;">{{newRoute.nr_ref}}</b></p>
        </v-card-title>
        <v-card-actions>
           <v-btn
            color="black"
            text
            @click="dialogRemoveRoute = false"
          >
            {{$t("close")}}
          </v-btn>
          <v-btn
            color="red"
            text
            @click="cancelRoute"
          >
            {{$t("anulacja")}}
          </v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
   </v-row>
   <div class="text-center">
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <v-card-title class="pb-0 mb-0 justify-center">
          <span class="headline">{{$t('addroute')}}</span>
        </v-card-title>
        <v-card-text class="pb-0 mb-0 pt-0 mt-0">
          <v-container>
            <v-form
            v-model="valid">
   <!-- ZIEJSCE ZALADUNKU -->
             <v-flex xs12>
                   <v-autocomplete
                  :items="itemsPlaces"
                  item-text="place_key"
                  v-model="newRoute.from_key"
                  label="Skąd"
                  block
                  required
                ></v-autocomplete>
              </v-flex>
 <!-- MIEJSCE ROZLADUNKU -->
             <v-flex xs12>
             <v-autocomplete
                  :items="itemsPlaces"
                  item-text="place_key"
                  v-model="newRoute.to_key"
                  label="Do"
                  required
                ></v-autocomplete>   
              </v-flex>

 <!-- NUMER REFERENCYJNY -->
             <v-flex xs12>
                <v-text-field
                  label="Numer referencyny"
                  v-model="newRoute.nr_ref"
                  required
                ></v-text-field>
              </v-flex>

<!-- DATA ODJAZDU -->
     <v-flex xs12>  
      <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        :return-value.sync="newRoute.dateLeft"
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.dateLeft"
            label="Data odjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker  :rules="nameRules"  locale="pl" v-model="newRoute.dateLeft" no-title scrollable>
          <div class="flex-grow-1"></div>
          <v-btn text color="primary" @click="menu2 = false">{{$t('close')}}</v-btn>
          <v-btn text color="primary" @click="$refs.menu2.save(newRoute.dateLeft)">OK</v-btn>
        </v-date-picker>
      </v-menu>
   </v-flex>

 <!-- CZAS ODJAZDU -->
     <v-flex xs12>
      <v-menu
        ref="menu3"
        v-model="menu3"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="newRoute.timeLeft"
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.timeLeft"
            label="Czas Odjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if=""
          v-model="newRoute.timeLeft"
          full-width
          format="24hr"
          @click:minute="$refs.menu3.save(newRoute.timeLeft)"
        ></v-time-picker>
      </v-menu>
    </v-flex>

        <!-- DATA PRZYJAZDU -->
    <v-flex xs12>
      <v-menu
        ref="menu0"
        v-model="menu0"
        :close-on-content-click="false"
        :return-value.sync="newRoute.dateArrive"
        transition="scale-transition"
        offset-y
        locale="pl"
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.dateArrive"
            label="Data przyjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker  locale="pl" v-model="newRoute.dateArrive" no-title scrollable>
          <div class="flex-grow-1"></div>
          <v-btn text color="primary" @click="menu0 = false">{{$t('close')}}</v-btn>
          <v-btn text color="primary" @click="$refs.menu0.save(newRoute.dateArrive)">OK</v-btn>
        </v-date-picker>
      </v-menu>
   </v-flex>
 <!-- CZAS PRZYJAZDU -->
    <v-flex xs12>
      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="newRoute.timeArrive"
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.timeArrive"
            label="Czas przyjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if=""
          format="24hr"
          v-model="newRoute.timeArrive"
          full-width
          @click:minute="$refs.menu1.save(newRoute.timeArrive)"
        ></v-time-picker>
      </v-menu>
   </v-flex>

          <!-- CARS -->
            <v-flex xs12>
                <v-autocomplete
                  :items="itemsCars"
                  item-text="nr_rej"
                  v-model="newRoute.id_car"
                  label="Ciężarówka"
   
                ></v-autocomplete>
              </v-flex>
            </v-row>
                 </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn  color="blue darken-4" text @click="( () => { dialog = false;setTimeout(()=>{this.newRoute = {};},500)})">{{$t("close")}}</v-btn>
          <v-btn color="blue darken-1" :disabled="!valid" text @click="sendNewRoute()">{{$t("save")}}</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
    <v-toolbar  dense color="transparent">
      <v-toolbar-title>    
        <v-layout row >
        
        <v-flex xs10>
  <v-menu
        ref="menu4"
        v-model="menu4"
        :close-on-content-click="false"
        :return-value.sync="dataNow"
        transition="scale-transition"
        offset-y
        full-width
        min-width="200px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dataNow"
            readonly
            prepend-icon="calendar_today"
            class="mt-3"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker  locale="pl" v-model="dataNow" no-title scrollable>
          <div class="flex-grow-1"></div>
          <v-btn text color="primary" @click="menu4 = false">{{$t('close')}}</v-btn>
          <v-btn text color="primary" @click="$refs.menu4.save(dataNow)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-flex></v-layout></v-toolbar-title>
        <v-btn class="ml-2" @click="changemode('country')" small color="red">Państwami</v-btn>
          <v-btn small class="ml-2" @click="changemode('dateLeft')">Datami</v-btn>
      <v-spacer></v-spacer>
       <v-btn @click="deleteon = !deleteon" icon>
        <v-icon>remove</v-icon>
      </v-btn>
      <v-btn @click="dialog = true" icon>
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table :mobile-breakpoint='200'  :search="searchtext"  hide-default-footer item-key="id" :items-per-page=1000  no-data-text="Brak rekordów"  :group-by="sortby" group-key="sortby"    :custom-sort="func" :headers="headers" :items="itemsRoutes"  class="elevation-0" >
      
            <template v-slot:item.to_key="{ item }">
             <div v-bind:class="{ bold: item.checked=='1'}">{{ item.to_key }}</div>
            </template>

              <template v-slot:item.from_key="{ item }">
             <div v-bind:class="{ bold: item.checked=='1'}">{{ item.from_key }}</div>
            </template>

            <template v-slot:item.nr_ref="{ item }">
             <div v-bind:class="{ bold: item.checked=='1'}">{{ item.nr_ref }}</div>
            </template>

            <template v-slot:item.checked="{ item }">
              <v-checkbox @change="updateChecked(item)"  v-model="item.checked == '1'" color="black" />
            </template>

           <template v-slot:item.timeleft="{ item }">
         <td  class="text-xs-left" style="color:green"><div style="color:green" v-if="checkDateDisplay(item.dateLeft)">{{item.dateLeft}}</div>{{item.timeleft }}</td>
           </template>

           <template v-slot:item.timearrive="{ item }">
          <td class="text-xs-left"><div v-if="checkDateDisplay(item.dateArrive)">{{item.dateArrive}}</div>{{item.timearrive }}</td>
           </template>

              <template v-slot:item.status="{ item }">
               <div v-if="item.cancel =='1'" class="caption">ANULACJA</div>
           </template>



           <template v-slot:item.action="{ item }">
         <div v-bind:style="item.cancel !='1' ? '' : 'background-color:rgba(0,0,0,0.1)'" class="text-xs-center">
              <v-btn v-if="item.cancel !='1' && !deleteon" @click="updateRouteDialog(item)"small text icon color="grey">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn v-if="item.cancel !='1' && !deleteon" @click="deleteRouteDialog(item)" small text icon color="red">
                <v-icon>remove</v-icon>
              </v-btn>
              <v-btn v-if="deleteon" @click="deleteRoute(item)" text small icon ><v-icon>delete_outline</v-icon></v-btn>
            </div>
           </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>
<script>
const axios = require('axios');
import moment from 'moment'
export default {
   computed: {
    routes() {
      return this.store.state.routes
    },
    search() {
      return this.store.state.searchtext
    },
    allcars(){
      return this.store.state.allcars
    },
     places(){
      return this.store.state.places;
    },
   dateNow() {
      return this.store.state.dateNow
    },
  },
  watch:{
     dateNow: {
      handler: function(newValue,oldValue) {
      this.dataNow = newValue;
      },
      deep: true
    },
    search:{ handler: function(newValue) {
      this.searchtext = newValue
      },
      deep: true
    },
     places: {
      handler: function(newValue) {
      this.itemsPlaces = newValue;

      },
      deep: true
    },
    routes: {
      handler: function(newValue,oldValue) {
      this.itemsRoutes = newValue;
      },
      deep: true
    },
     allcars: {
      handler: function(newValue,oldValue) {
      this.itemsCars = newValue;
      },
      deep: true
    },
     dataNow(value){
      this.store.state.dateNow = this.dataNow;
     }
  },

  mounted(){
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    this.store.state.dateNow = new Date().toISOString().substr(0, 10);
  },
methods: {
 func(items, index, isDesc) {
    return items
  },
  checkDateDisplay(date){
  if(date != this.dataNow)return true
  },
  converttime(salut) {
    let now = moment().utc();
    let arrive = moment(salut.time_arrive)
    let left =  moment(salut.time_left)
     let  alltimedrive = left.diff(arrive,'hours');
     let realtimedrive = now.diff(left,'hours');
      if(Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))>0)return Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))
        else return 0 
      
  },
  updateRouteDialog(route){
    this.newRoute = route;
    this.dialog=true;
  },

  changemode(value){
    this.sortby = value;
    this.store.state.sortby = value;
  },

  updateChecked(route){
    this.newRoute = route;
    if(route.checked == "0")this.newRoute.checked="1"
      else {this.newRoute.checked="0"}
    this.sendNewRoute();
  },
  checkChecked(check){
    return true;
    if(check == "1") return true
      else return false;
  },
  getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
 
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
    },

deleteRouteDialog(item){
this.dialogRemoveRoute = true;
this.newRoute=item;
},

deleteRoute(item){
     this.newRoute=item;
     var data=this;
     var jwt = this.getCookie('jwt');
     if(this.newRoute.id != null){

     axios.post('http://'+location.hostname+'/transportapp/php_file/delete.php', {
           jwt :jwt,
           data:data.newRoute
    })
     .then(function (response) {
      console.log(response)
      data.newRoute = {};
      data.dialogRemoveRoute = false;
     })
     .catch(function (error) {
       console.log(error);
     });
   }
},

cancelRoute(){
     var data=this;
     var jwt = this.getCookie('jwt');
     if(this.newRoute.id != null){

     axios.post('http://'+location.hostname+'/transportapp/php_file/cancel.php', {
           jwt :jwt,
           data:data.newRoute
    })
     .then(function (response) {
      data.newRoute = {};
      data.dialogRemoveRoute = false;
     })
     .catch(function (error) {
       console.log(error);
     });
   }
},





  sendNewRoute(){
     var data=this;
     var jwt = this.getCookie('jwt');
     let datetimeArrive = this.newRoute.dateArrive+' '+this.newRoute.timeArrive+':00'
     let datetimeLeft = this.newRoute.dateLeft+' '+this.newRoute.timeLeft+':00'
     this.newRoute.time_arrive = datetimeArrive;
     this.newRoute.time_left = datetimeLeft;
     if(this.newRoute.id != null){
     axios.post('http://'+location.hostname+'/transportapp/php_file/update.php', {
           jwt :jwt,
           data: data.newRoute
          
    })
     .then(function (response) {
      data.newRoute = {};
      if(data.dialog)data.dialog = false;
      
    
     })
     .catch(function (error) {
       console.log(error);
     });
     }
     else {
     axios.post('http://'+location.hostname+'/transportapp/php_file/create.php', {
           jwt :jwt,
           data:data.newRoute
    })
     .then(function (response) {
      data.newRoute = {};
      data.dialog = false;
     })
     .catch(function (error) {
       console.log(error);
     });
  }
}
},

  data() {
    return {
      dataNow:this.store.state.dateNow,
      dialog:false,
      deleteon:false,
      itemsRoutes:this.store.state.routes || [],
      itemsCars: this.store.state.allcars || [],
      itemsPlaces: this.store.state.places || [],
      newRoute:{},
      sortby:'country',
     // arrdesc:["NL","DE","FR","ES","IT","CZECHY","SL","PL"],
      arrdesc:[2,8,6],
      dialogRemoveRoute:false,
      menu0:false,
      menu1:false,
      menu2:false,
      valid:true,
      menu3:false,
      menu4:false,
      searchtext:null,
      nameRules: [
        v => !!v || '*Wymagane',
        ],
      headers: [
       { text: "", value: "checked", align: "left" },
      {text:"Kraj",
      value:"country"},
     
        {
          text: "Skąd",
          align: "left",
          value: "from_key",
        },
        {
          text: "Do",
          align: "left",
          value: "to_key"
        },
        { text: "Numer Referencyjny", value: "nr_ref", align: "left" },
        { text: "Czas Odjazdu", value: "timeleft" },
        { text: "Czas Przyjazdu", value: "timearrive" },
        { text: "Status", value:"status"},
        { text: "Pojazd", value: "id_car", align: "left" },
        { text: "Akcje", value: "action", align: "center" }
      ]
    }
  },
  }
</script>
<style>
.cancelClass{
  background-color: red !important;
}
.activeClass{
  color: red !important;
}

.bold{
  font-weight: bold;
}

</style>
